import { View } from 'react-native'
import Status from '@ui/elements/Status'
import { Measurement, Side } from '../types'
import { useTranslation } from 'react-i18next'
import Button from '@ui/buttons/Button'
import cn from '@ui/utils/cn'

interface Props {
  measurement: Measurement
  side: Side
  onChange: (side: Side) => void
  className?: string
}

export default function ManualSidesSwitch({
  measurement,
  side,
  onChange,
  className,
}: Props) {
  const { t } = useTranslation(['measurement', 'ui'])
  const tNamespace = `measurement:app.manual`
  const tl = `${tNamespace}.${measurement}`

  return (
    <View
      className={cn(
        'flex  flex-row items-center justify-between gap-8',
        className
      )}
    >
      <Button
        variant="outlined"
        size="sm"
        iconStart="chevron-left"
        onPress={() => onChange('l')}
        disabled={side === 'l'}
      />
      <Status variant="danger" text={t(`${tl}.results.${side}.label`)} />
      <Button
        variant="outlined"
        size="sm"
        iconStart="chevron-right"
        onPress={() => onChange('r')}
        disabled={side === 'r'}
      />
    </View>
  )
}
